import { createContext } from "react";
import useApp from "../hooks/useApp";
import { APP_MAINTENANCE_MODE } from "lib/constants";

const AppContext = createContext<AppState>(null);

const AppContextProvider = ({ children, value }: ComponentProps) => {
  return (
    <AppContext.Provider value={useApp(APP_MAINTENANCE_MODE)}>
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppContextProvider };
